<template>
  <span>
    <form-wizard
      color="#17a2b8"
      stepSize="xs"
      subtitle=""
      title="Assistant d'export des reçus fiscaux"
      @on-change="onChangeTab"
    >
      <tab-content
        :beforeChange="beforeChangeEtapeUne()"
        title="Choix de l'année"
      >
        <etape-une ref="etapeUne" v-model="selectedYear" />
      </tab-content>
      <tab-content title="Message par défaut">
        <etape-deux ref="etapeDeux" v-model="recuFiscalParam.message" />
      </tab-content>
      <tab-content title="Vérifications">
        <etape-trois :table-data="recuFiscalParam.recuFiscaux" />
      </tab-content>
      <tab-content title="Envoi">
        <etape-quatre :year="recuFiscalParam.year" />
      </tab-content>

      <b-button slot="next" type="primary">Suivant</b-button>
      <b-button slot="prev" type="primary">Précedent</b-button>
      <b-button slot="finish" v-b-modal.modal-1 type="primary">Fin</b-button>
    </form-wizard>
    <b-modal id="modal-1" title="Fermeture" @ok="$emit('close')">
      <p class="my-4">Confirmez-vous la fermeture de l'assistant d'export ?</p>
    </b-modal>
  </span>
</template>
<script>
import ToastService from "../../service/toastService";
import ExportEtape1Annee from "./ExportEtape1Annee";
import ExportEtape2Message from "./ExportEtape2Message";
import ExportEtape3Fichier from "./ExportEtape3Fichier";
import ExportEtape4Fichier from "./ExportEtape4Envoi";
import { FormWizard, TabContent } from "vue-form-wizard";
import ApiService from "../../service/apiService";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "AssistantExport",
  components: {
    etapeUne: ExportEtape1Annee,
    etapeDeux: ExportEtape2Message,
    etapeTrois: ExportEtape3Fichier,
    etapeQuatre: ExportEtape4Fichier,
    FormWizard: FormWizard,
    TabContent: TabContent,
  },
  data() {
    return {
      recuFiscalParam: {},
      selectedYear: "",
    };
  },

  methods: {
    async findExistingRecusFiscaux() {
      if (this.selectedYear) {
        var response = await ApiService.recuFiscal.findByYear(
          this.selectedYear
        );
        if (response.data) {
          this.recuFiscalParam = response.data;
          this.$refs.etapeDeux.refreshEditor(response.data.message);
        } else {
          this.recuFiscalParam = { year: this.selectedYear };
          this.$refs.etapeDeux.refreshEditor("");
        }
      } else {
        this.recuFiscalParam = {};
      }
    },
    async onChangeTab(prevIndex, nextIndex) {
      if (nextIndex > prevIndex) {
        switch (prevIndex) {
          case 1:
            var resp = await ApiService.recuFiscal.save(this.recuFiscalParam);
            if (resp.data) {
              this.recuFiscalParam = resp.data;
            }
            break;
          case 2:
            var resp = await ApiService.recuFiscal.createFiles(
              this.recuFiscalParam
            );
            if (resp.success) {
              ToastService.displaySuccessToast(
                "Les fichiers ont bien été créé"
              );
            }
          default:
            break;
        }
      }
    },
    beforeChangeEtapeUne() {
      var vm = this;
      return function () {
        var canNext = false;
        if (vm.selectedYear) {
          canNext = true;
        } else {
          ToastService.displayErrorToast("L'année doit être selectionnée");
          canNext = false;
        }

        if (
          !vm.$refs.etapeUne.checkedSaisie ||
          vm.$refs.etapeUne.saisieError.length > 0
        ) {
          ToastService.displayErrorToast(
            "Il faut corriger les erreurs avant de pouvoir continuer"
          );
          canNext = false;
        }

        if (canNext) {
          vm.findExistingRecusFiscaux();
        }
        return canNext;
      };
    },
  },
};
</script>
